import Service from '../service.js';
import { errorMessage } from '@/utils/message.js';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      bankId: '',
      detail: {},
      quikPayFlagList: [
        {id: 1, code: '1', value: '未开通'},
        {id: 2, code: '2', value: '已开通'},
        {id: 3, code: '3', value: '处理中'}
      ]
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    this.bankId = this.$route.query.bankId;
    this.getBankDetail();
  },
  methods: {
    // 返回
    goBack () {
      this.$router.push('/person-center/account-info/bank-account-manage/list');
    },
    // 获取发票详情
    getBankDetail(){
      Service.getBankDetail(this.bankId).then(res => {
        if (res && res.code === '0') {
          this.detail = res.data;
        } else {
          errorMessage(res && res.reason);
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    },
    previousStep () {
      this.$router.back();
    }
  }
};
